import React from 'react';
import { ErrorMessage, NestDataObject } from 'react-hook-form';
import { makeErrorPanelStyles } from 'styles/components/errorPanel';

type Props = {
    errors: NestDataObject<any, any>;
    name: string;
};

const ErrorPanel: React.FC<Props> = ({ errors, name }) => {
    const { errorPanel } = makeErrorPanelStyles();

    return (
        <ErrorMessage errors={errors} name={name}>
            {({ message, messages }) => <p className={errorPanel}>{message}</p>}
        </ErrorMessage>
    );
};

export default ErrorPanel;
